import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@common/components/button';
import Profile from '@common/components/profile';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '@common/hooks/redux';

type Props = {
  userId: string;
  name: string;
  image: string;
  hideBorderBottom: boolean;
  accessRequestId: string;
  isActionLoading: (accessRequestId: string, action: 'approve' | 'reject') => boolean;
  onApprove: () => void;
  onReject: () => void;
  closeModal: () => void;
};

const AccessRequestsItem: React.FC<Props> = ({
 name, image, hideBorderBottom = false, accessRequestId, isActionLoading, onApprove, onReject, userId, closeModal
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const networkId = useAppSelector((store) => store.network.selected);
  const handleClick = useCallback(() => {
    history.push(`/networks/${networkId}/users/${userId}`);
    closeModal();
  }, [history, networkId, userId, closeModal]);
  return (
    <div
      className={`tw-flex tw-flex-row tw-gap-2 tw-justify-between tw-border-0 ${
        hideBorderBottom ? '' : 'tw-border-b'
      } tw-border-solid tw-border-gray-custom-100 tw-py-2`}
    >
      <Profile
        size={28}
        user={{ profile_img: image, full_name: name, nameClassName: 'tw-line-clamp-1' }}
        onClick={handleClick}
      />
      <div className="tw-flex tw-flex-row">
        <Button
          isLoading={isActionLoading(accessRequestId, 'reject')}
          disabled={isActionLoading(accessRequestId, 'approve') || isActionLoading(accessRequestId, 'reject')}
          type="inverted"
          size="small"
          className="tw-text-red-link hover:!tw-text-red-link hover:!tw-bg-red-light"
          onClick={onReject}
        >
          {t('social:access_request_reject')}
        </Button>
        <Button
          isLoading={isActionLoading(accessRequestId, 'approve')}
          disabled={isActionLoading(accessRequestId, 'approve') || isActionLoading(accessRequestId, 'reject')}
          type="inverted-primary"
          size="small"
          onClick={onApprove}
        >
          {t('social:access_request_approve')}
        </Button>
      </div>
    </div>
  );
};

export default AccessRequestsItem;
